/**
 * @file LoadingOverlay.jsx
 * @author Rishikesh
 * @date 2024-09-09
 * @description Overlay component used in Auth pages.
 */
import {
  Box,
  CircularProgress,
  Stack,
  colors,
  circularProgressClasses,
} from "@mui/material";

export const LoadingOverlay = ({ loginProgress }) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    sx={{
      height: "100%",
      width: "100%",
      position: "absolute",
      top: 0,
      left: 0,
      bgcolor: colors.common.white,
      zIndex: 1000,
    }}
  >
    <Box position="relative">
      <CircularProgress
        variant="determinate"
        value={loginProgress}
        size={100}
        sx={{
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
          position: "absolute",
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          color: colors.green[600],
        }}
      />
    </Box>
  </Stack>
);
